import { render, staticRenderFns } from "./pgProfile.vue?vue&type=template&id=de674dd6&scoped=true&"
import script from "./pgProfile.vue?vue&type=script&lang=js&"
export * from "./pgProfile.vue?vue&type=script&lang=js&"
import style0 from "./pgProfile.vue?vue&type=style&index=0&id=de674dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de674dd6",
  null
  
)

export default component.exports